// const config = {
//     cn: {
//         edu: 'https://api.edu.cocorobo.cn/edu/',
//         api: 'https://beta.api.cocorobo.cn/',
//     },
//     hk: {
//         edu: 'https://api.edu.cocorobo.hk/edu/',
//         api: 'https://beta.api.cocorobo.hk/',
//     },
//     com: {
//         edu: 'https://api.edu.cocorobo.com/edu/',
//         api: 'https://beta.api.cocorobo.com/',
//     }
// }
const config = {}
if (window.location.hostname.indexOf('cocorobo.com') > -1) {
    config.edu = 'https://api.edu.cocorobo.cn/edu/';
    config.api = 'https://cloud.api.cocorobo.com/';
} else if (window.location.hostname.indexOf('cocorobo.hk') > -1) {
    config.edu = 'https://api.edu.cocorobo.cn/edu/';
    config.api = 'https://cloud.api.cocorobo.hk/';
} else {
    config.edu = 'https://api.edu.cocorobo.cn/edu/';
    config.api = 'https://beta.api.cocorobo.cn/';
}

export default config;